import { InfoIcon } from "lucide-react";
import React from "react";
import { Grid, GridRow, Popup } from "semantic-ui-react";
import defaultUserImage from "../../../../assets/images/default_icon.jpeg";
import {
  InputText,
  InputTextArea,
  NewImageUploader,
  Switch,
  TitleView
} from "../../../../components";
import { DISABLE_IS_ROOT_PRODUCT_BUTTON } from "../../../../config/constants";
import { IsRootProduct } from "../../../../config/enums/ProductType.enum";
import { ProductInfoFormProps } from "../types/productTypes";

const ProductInfoForm: React.FC<ProductInfoFormProps> = ({
  register,
  errors,
  productType,
  setProductType,
  isRootProduct,
  enableAverageProduct,
  setImageData
}) => {
  const titleWithPopup = [
    <Grid>
      <GridRow textAlign="center" className="pl-1 customButtonAverageSwitch">
        <span>Average Impact Product</span>
        <Popup
          content={`Generates an ''average product'' using the carbon footprint and volume of selected products`}
          trigger={<InfoIcon className="ml-1" size={20} color="green" />}
        />
      </GridRow>
    </Grid>
  ];

  return (
    <>
      <TitleView title="Product Info" CustomTitleViewMain="productRegisterTitle" />
      <Grid>
        <Grid.Column computer={16} tablet={16} mobile={16}>
          <Grid>
            <Grid.Column computer={8} tablet={16} mobile={16}>
              <InputText
                register={register}
                errors={errors.product_name}
                labelName="Name*"
                placeholder="Name"
                name="product_name"
                required
                errorMessage="Please enter product name"
                validateHandle={(value: string) =>
                  value?.length <= 32 || "Maximum 32 characters allowed"
                }
              />
            </Grid.Column>
            <Grid.Column computer={8} tablet={16} mobile={16}>
              <InputText
                register={register}
                errors={errors.registration_number}
                labelName="Register Number"
                placeholder="Register Number"
                name="registration_number"
                validateHandle={(value: string) =>
                  value?.length <= 32 || "Maximum 32 characters allowed"
                }
              />
            </Grid.Column>
            <Grid.Column computer={8} tablet={16} mobile={16}>
              <Switch
                label="Product Type"
                onClick={setProductType}
                titleOne="Processed Product"
                titleTwo="Farm Product"
                defaultValue="PROCESS"
                titleOneValue="PROCESS"
                titleTwoValue="FARM"
              />
            </Grid.Column>
            {!DISABLE_IS_ROOT_PRODUCT_BUTTON && (
              <Grid.Column computer={8} tablet={16} mobile={16}>
                <Switch
                  customTitleStatus
                  customTitle={titleWithPopup}
                  onClick={enableAverageProduct}
                  titleOne={IsRootProduct.YES}
                  titleTwo={IsRootProduct.NO}
                  defaultValue={isRootProduct}
                  titleOneValue={IsRootProduct.YES}
                  titleTwoValue={IsRootProduct.NO}
                />
              </Grid.Column>
            )}
            <Grid.Column computer={8} tablet={16} mobile={16}>
              <NewImageUploader
                buttonTitle="Upload an Image"
                customImageViewMain="customProductImageView"
                imageData={setImageData}
              />
            </Grid.Column>
            <Grid.Column computer={16} tablet={16} mobile={16}>
              <InputTextArea
                register={register}
                errors={errors.product_other_info}
                labelName="Additional Information"
                placeholder="Additional Information"
                name="product_other_info"
                customInputValidation
              />
            </Grid.Column>
          </Grid>
        </Grid.Column>
      </Grid>
    </>
  );
};

export default ProductInfoForm;
